export const TECHNOLOGY_MAPPING: Record<string, { label: string; description: string }> = {
  'Adsl': {
    label: 'ADSL',
    description: 'wan.technology.adsl.description'
  },
  'Fibre': {
    label: 'FTTO',
    description: 'wan.technology.ftto.description'
  },
  'FTTH': {
    label: 'FTTH',
    description: 'wan.technology.ftth.description'
  },
  'IPSEC': {
    label: 'MASQUER',
    description: ''
  },
  'Mobile': {
    label: 'Mobile',
    description: 'wan.technology.mobile.description'
  },
  'openvpn': {
    label: 'MASQUER',
    description: ''
  },
  'Satellite': {
    label: 'Satellite',
    description: 'wan.technology.satellite.description'
  },
  'VDSL': {
    label: 'VDSL',
    description: 'wan.technology.vdsl.description'
  }
}

export const FUNCTION_MAPPING: Record<string, {
  label: string;
  description: string;
  wifirstDescription?: string;
  clientWithIpsecDescription?: string;
  clientWithIpsecTooltip?: string;
}> = {
  'accor_management': {
    label: 'wan.function.accor_management.label',
    description: 'wan.function.accor_management.description'
  },
  'customer_access': {
    label: 'wan.function.customer_access.label',
    description: 'wan.function.customer_access.description'
  },
  'management_backup': {
    label: 'wan.function.management_backup.label',
    description: 'wan.function.management_backup.description'
  },
  'management_only': {
    label: 'wan.function.management_only.label',
    description: 'wan.function.management_only.description'
  },
  'si_access': {
    label: 'A MASQUER',
    description: ''
  },
  'wan_access': {
    label: 'wan.function.wan_access.label',
    description: 'wan.function.wan_access.description',
    wifirstDescription: 'wan.function.wan_access.wifirst_description',
    clientWithIpsecDescription: 'wan.function.wan_access.client_with_ipsec_description',
    clientWithIpsecTooltip: 'wan.function.wan_access.client_with_ipsec_tooltip'
  },
  'wan_backup': {
    label: 'wan.function.wan_backup.label',
    description: 'wan.function.wan_backup.description'
  }
}

export interface ProviderOption {
  value: string;
  label: string;
}

export const PROVIDER_OPTIONS: ProviderOption[] = [
  { value: 'wifirst', label: 'Wifirst' },
  { value: 'client', label: 'Client' }
]

export const DOWNLOAD_COLOR = '#59B5DB'
export const UPLOAD_COLOR = '#FDAE61'
export const PING_COLOR = '#59B5DB'
export const LOSS_COLOR = '#FDAE61'
export const DROPPED_PACKETS_DOWNLOAD_COLOR = '#F34E86'
export const DROPPED_PACKETS_UPLOAD_COLOR = '#8364c5ff'

export const axisStyle = {
  fontSize: 10,
  fill: '#A2AAB8',
}
